<template>
  <div class="work-parcel-list">
    <label class="control-label">{{title}}</label>
    <div class="parcels">
      <div class="parcel" v-for="parcel in items ?? []" :key="parcel.uuid">
        <work-parcel-item :data="parcel" class="parcel-data d-flex flex-row"/>
      </div>
    </div>
  </div>
</template>
<script>
import WorkParcelItem from "@/pages/works/applyArticles/partials/WorkApiDialog/WorkParcelList/WorkParcelItem.vue";

export default {
  name: 'WorkParcelList',
  components: {WorkParcelItem},
  props: ['data', 'title'],
  data() {
    return {
      items: this.data ?? [],
    }
  },
  watch: {
    data: {
      handler: function (newVal) {
        this.items = newVal;
      },
      deep: true,
    }
  }
}
</script>
